module.exports = __webpack_public_path__ + "img/section-awards-main.ca79895c.png";